const fundProjects = [
    {
        fundingAgency: " INDIAN COUNCIL OF MEDICAL RESEARCH " ,
        title: "Smartphone Imaging-Based Artificial Intelligence Model for Early Detection and Screening of Ocular Surface and Eyelid Tumours: A Multicentric Study",
        amount: "₹ 66,00,000",
        duration: "2 years"
    },
    
     
    {
        fundingAgency: "Mozilla RCC",
        title: "Framework to gain Insights on Fairness, Accountability, and Transparency of Algorithms from a Sociological Perspective",
        amount: "$ 25,000",
        duration: "1 years"
    },
    {
      fundingAgency: "Volkswagen Foundation",
      title: "Artificial Intelligence for Social Assessment (AIFORA)",
      amount: "₹ 24,00,000",
      duration: "3 years"
    },
    {
      fundingAgency: "IIT Palakkad",
      title: "Doctoral student Fellowship [Recipient Dr Divya SindhuLekha]",
      amount: "₹ 21,84,000",
      duration: "5 years"
    },
    {
      fundingAgency: "IIT Palakkad",
      title: "Doctoral student Fellowship [Recipient Dr Ebin Deni Raj]",
      amount: "₹ 21,84,000",
      duration: "5 years"
    },
    
  ];

  export default fundProjects;